import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";
import * as types from "@/app/types";

export default class APIAudioFiles extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getAudioFiles = async (): Promise<types.AudioFileList> => {
    let res = await this._fetch({
      url: "/audio-files/",
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getAudioFile = async (audioFileId: UUID): Promise<types.AudioFile> => {
    let res = await this._fetch({
      url: `/audio-files/${audioFileId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  uploadAudioFile = async (
    body: types.BodyUploadAudioFile,
  ): Promise<types.AudioFile> => {
    let res = await this._fetch({
      url: "/audio-files/",
      method: "POST",
      body: body,
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  deleteAudioFile = async (audioFileId: UUID): Promise<void> => {
    await this._fetch({
      url: `/audio-files/${audioFileId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
  };

  getAudioFileContent = async (audioFileId: UUID): Promise<Response> => {
    return await this._fetch({
      url: `/audio-files/${audioFileId}/content`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
  };
}
